import type { HeroBentoCardType } from '@coursera-web/cds-labs';

import AISkillsDesktop from 'images/front-page/AISkillsDesktop.png';
import AISkillsMobile from 'images/front-page/AISkillsMobile.png';
import C4BDesktop from 'images/front-page/C4BDesktop.png';
import C4BMobile from 'images/front-page/C4BMobile.png';
import JoinForFreeDesktop from 'images/front-page/JoinForFreeDesktop.png';
import JoinForFreeMobile from 'images/front-page/JoinForFreeMobile.png';
import WesTentpoleDesktop from 'images/front-page/WesTentpoleDesktop.png';
import WesTentpoleMobile from 'images/front-page/WesTentpoleMobile.png';

import _t from 'i18n!nls/front-page';

type PredefinedPromos = Record<'joinForFree' | 'c4b' | 'wesTentpole' | 'promoCert', HeroBentoCardType>;

const getPredefinedPromos = (): PredefinedPromos => ({
  joinForFree: {
    id: 'joinForFree',
    backgroundColor: 'tertiary-yellow-xweak',
    headline: _t('Start, switch, or advance your career'),
    description: _t('Grow with 10,000+ courses from top organizations'),
    desktopImage: {
      url: JoinForFreeDesktop,
      width: 330,
      height: 304,
    },
    mobileImage: {
      url: JoinForFreeMobile,
      width: 232,
      height: 138,
    },
    cta: {
      target: 'sign-in-modal',
      label: _t('Join for Free'),
      variant: 'primary',
    },
  },
  c4b: {
    id: 'c4b',
    backgroundColor: 'neutral-grey-weak',
    headline: _t('Drive your business forward and empower your talent'),
    description: _t('Train teams with industry-leading experts'),
    desktopImage: {
      url: C4BDesktop,
      width: 330,
      height: 304,
    },
    mobileImage: {
      url: C4BMobile,
      width: 232,
      height: 138,
    },
    cta: {
      target:
        'business?utm_campaign=website&utm_content=banner-from-B2C-home-try-business&utm_medium=coursera&utm_source=enterprise&utm_term=treatment',
      label: _t('Try Coursera for Business'),
      variant: 'primary',
    },
  },
  wesTentpole: {
    id: 'wesTentpole',
    backgroundColor: 'dark-blue',
    headline: _t('Train your team in top skills and join 4,500+ teams worldwide'),
    desktopImage: {
      url: WesTentpoleDesktop,
      width: 330,
      height: 304,
    },
    mobileImage: { url: WesTentpoleMobile, width: 232, height: 276 },
    cta: {
      target:
        '/business/teams?promoCode=aug30-2025&utm_medium=coursera&utm_source=home-page&utm_campaign=2025-aug-promo&utm_content=hero-cta&utm_term=treatment',
      label: _t('Save on Teams'),
    },
  },
  promoCert: {
    id: 'promoCert',
    backgroundColor: 'primary-blue-xxstrong',
    headline: _t('Gain essential AI skills by learning from AI experts and industry leaders'),
    desktopImage: {
      url: AISkillsDesktop,
      width: 330,
      height: 304,
    },
    mobileImage: {
      url: AISkillsMobile,
      width: 232,
      height: 138,
    },
    cta: {
      target: 'explore/generative-ai',
      label: _t('Explore programs'),
    },
  },
});

export default getPredefinedPromos;
